import { Spin } from 'platform-components';
import React from 'react';

import EmptyState, { EMPTY_STATE_ACTION } from '../../empty-state/empty-state';
import { useCourseContainers } from '../../library.course-container/with-course-container';

export const CourseJournalEmptyNoLessons = () => {
    const courseContainersQuery = useCourseContainers();
    const hasCourseContainers = courseContainersQuery.data?.length;

    if (!courseContainersQuery.isSuccess) {
        return (
            <div className="course-journal__spinner">
                <Spin center />
            </div>
        );
    }

    return (
        <EmptyState
            action={hasCourseContainers ? EMPTY_STATE_ACTION.GO_TO_COURSE_CONTAINER : EMPTY_STATE_ACTION.ADD_LESSON}
            textId={
                hasCourseContainers
                    ? 'courseJournal.emptyState.informatics.description'
                    : 'courseJournal.emptyState.description'
            }
            unavailableSubjectHeaderId="courseJournal.emptyState.unavailableSubject.header"
        />
    );
};
